export default __webpack_public_path__ + "static/media/define2.6ec17c49.png";